import { LogOut, Ban, ClipboardList, User } from "lucide-react";
import { Button, Tooltip, type SelectChangeEvent, Box, IconButton, Dialog, DialogContent, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { ApiGenerateLoginToken, ApiPutShopperDetails, ApiPutUpdateShopperApplicationStatus } from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { CancelOutlined } from "@mui/icons-material";

const Dcrage = ({ loanData, handleClose }) => {
  const [shopperNotes, setShopperNotes] = useState(loanData?.shopperOtherDetail?.shopperNotes);
  const [trainingNotes, setTrainingNotes] = useState(loanData?.shopperOtherDetail?.trainingNotes);
  const [staticLineInserted, setStaticLineInserted] = useState(false);
  const [staticLineInserted2, setStaticLineInserted2] = useState(false);
  const shoppernoteRef = useRef<HTMLTextAreaElement | null>(null);
  const trainingnoteRef = useRef<HTMLTextAreaElement | null>(null);
  const navigate = useNavigate()
  const popupRef = useRef<HTMLDivElement>(null);
  const [openReasonDialog, setOpenReasonDialog] = useState(false);
  const [reasonForDeactive, setReasonForDeactive] = useState("");
  


  // useEffect(() => {
  //   function handleClickOutside(event: any) {
  //     if (popupRef.current && !popupRef.current.contains(event.target)) {
  //       handleClose();
  //     }
  //   }

  //   document.addEventListener("mousedown", handleClickOutside);

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [popupRef]);

  console.log(loanData);
  useEffect(() => {
    setShopperNotes(loanData?.shopperOtherDetail?.shopperNotes)
    setTrainingNotes(loanData?.shopperOtherDetail?.trainingNotes)
  }, [loanData])
  const getTimeSinceCreated = (createdOn: string): string => {
    if (!createdOn) return "N/A";

    const createdDate = new Date(createdOn);
    const now = new Date();

    const diffYears = now.getFullYear() - createdDate.getFullYear();
    const diffMonths =
      (now.getFullYear() - createdDate.getFullYear()) * 12 +
      (now.getMonth() - createdDate.getMonth());

    if (diffYears >= 1) {
      return `${diffYears} year${diffYears > 1 ? "s" : ""} ago`;
    } else if (diffMonths >= 1) {
      return `${diffMonths} month${diffMonths > 1 ? "s" : ""} ago`;
    } else {
      return "Less than a month ago";
    }
  };

  const formatDate = (dateString: string): string => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const saveShopperNotes = async (userId: any) => {
    try {
      const data = {
        userId: userId,
        shopperNotes: shopperNotes,
      };
      const response = ApiPutShopperDetails(data);

      toast.success("Shopper notes saved successfully");
    } catch (error) {
      console.error("Error saving shopper notes:", error);
      toast.error("Error saving shopper notes");
    }
  };

  const saveTrainingNotes = async (userId: any) => {
    try {
      const data = {
        userId: userId,
        trainingNotes: trainingNotes,
      };
      const response = ApiPutShopperDetails(data);
      toast.success("Training notes saved successfully");
    } catch (error) {
      console.error("Error saving training notes:", error);
      toast.error("Error saving training notes");
    }
  };

  const navigateToLoginShopper = async (userId: any) => {

    try {
      const data = {
        adminUserId: localStorage.getItem('userRole'),
        targetUserId: userId,
        ipAddress: '127.0.0.1',
        browserName: 'Google chrome'

      }
      const res = await ApiGenerateLoginToken(data)
      if (res.success) {
        window.open(`${process.env.REACT_APP_SHOPPER_SITE}?adminuserid=${localStorage.getItem('userId')}&validation=${res.data.token}`, '_blank');
      }
    } catch (error) {
      console.log(error)
    }

  }
  const navigateToViewShopperApplication = (shopper: any) => {
    // navigate("/admin/shoppers/edit_shopper_profile", {
    //   state: { shopperDetails: shopper },
    sessionStorage.setItem('userDetailsState', JSON.stringify(shopper));
    window.open(`/admin/shoppers/edit_shopper_profile/${shopper?.userId}`, '_blank');
    // })
  }
  const navigateToDrivingLicence = (driving_licence: string) => {
    // 1. Copy some text to clipboard
    const textToCopy = "AdelaideL2007";
    navigator?.clipboard?.writeText(textToCopy)?.then(
      () => {
        toast.info("password is copied to clipboard");
      },
      (err) => {
        toast.error("Failed to copy text: ", err);
      }
    );
    // 2. Open PDF in a new window/tab
    window.open(driving_licence, "_blank");


  };

  const handleOnFocus = (e: any) => {

    if (!staticLineInserted) {
      e.preventDefault(); // prevent newline from default action
      // const now = new Date();
      // const formatted = now.toLocaleString(); // e.g., 7/14/2025, 12:35:10 PM
      const now = new Date();

      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();

      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 ⇒ 12

      const formatted = `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
      const staticLine = `${localStorage.getItem("userName")}-${formatted}:\n`
      const updatedText = `${staticLine}\n${shopperNotes?.length > 1 ? `${shopperNotes}\n` : ""}`; // add static line
      setShopperNotes(updatedText);
      setStaticLineInserted(true);

      setTimeout(() => {
        const textarea = shoppernoteRef && shoppernoteRef.current;
        if (textarea) {
          textarea.focus(); // ensure focus
          textarea.setSelectionRange(staticLine.length, staticLine.length);
        }
      }, 0);

    }
  };

  const handleOnFocus2 = (e: any) => {

    if (!staticLineInserted2) {
      e.preventDefault(); // prevent newline from default action
      // const now = new Date();
      // const formatted = now.toLocaleString(); // e.g., 7/14/2025, 12:35:10 PM
      const now = new Date();

      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();

      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 ⇒ 12

      const formatted = `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
      const staticLine = `${localStorage.getItem("userName")}-${formatted}\n`;
      const updatedText = `${staticLine}\n${trainingNotes?.length > 1 ? `${trainingNotes}\n` : ""}`; // add static line
      setTrainingNotes(updatedText);
      setStaticLineInserted2(true);

      setTimeout(() => {
        const textarea = trainingnoteRef && trainingnoteRef.current;
        if (textarea) {
          textarea.focus(); // ensure focus
          textarea.setSelectionRange(staticLine.length, staticLine.length);
        }
      }, 0);

    }
  };


   const handleSubmitDeactiveReason = async () => {
      if (!reasonForDeactive || reasonForDeactive.trim().length === 0) {
        alert("Reason is required");
        return;
      }
  
      try {
        const payload = {
          userId: loanData?.userId,
          status: "deActivated",
          rejectReason: reasonForDeactive
        };
        await ApiPutUpdateShopperApplicationStatus(payload);
        toast.success("Shopper Deactivated Successfully");
        setOpenReasonDialog(false);
        setReasonForDeactive("");
      } catch (error) {
        toast.error("Error updating status");
      }
    };
  return (
    // <div className="loanData-model" onMouseLeave={handleClose}>
    <Box className='w-100' maxWidth={'600px'} overflow={'auto'}>
      <div className="loanData-model w-100" ref={popupRef} onClick={(e) => e.stopPropagation()}>
        <div className="profile-container w-100">
          <div className="profile-card w-100">
            <div className="profile-header w-100">
              <div className="profile-title w-100 d-flex justify-content-between">
                <h2>
                  {loanData?.firstName} {loanData?.lastName}{" "}
                </h2>
                <IconButton onClick={handleClose} className="p-0">
                  <CancelOutlined />
                </IconButton>
                {/* <span className='status-badge'>Incomplete Profile</span> */}
              </div>
              <hr></hr>
              <div className="action-buttons">
                <Button onClick={() => { navigateToLoginShopper(loanData?.userId) }} className="icon-button table-row-background">
                  <Tooltip title='login'><LogOut size={20} color="white" /></Tooltip>
                </Button>
                <Button className="icon-button table-row-background" onClick={() => { setOpenReasonDialog(true); }}>
                  <Tooltip title='Deactivate Shopper'><Ban size={20} color="white" /></Tooltip>
                </Button>
                <Button onClick={() => { navigateToDrivingLicence(loanData?.driving_licence) }} className="icon-button table-row-background">
                  <Tooltip title='document'><ClipboardList size={20} color="white" /></Tooltip>
                </Button>
                <Button onClick={() => { navigateToViewShopperApplication(loanData) }} className="icon-button table-row-background">
                  <Tooltip title='profile'><User size={20} color="white" /></Tooltip>
                </Button>
              </div>
            </div>
            <h5>Contact Details:</h5>
            <div className="contact-details table-row-background">
              <div className="contact-item">
                <div className="label">Age:</div>
                <div className="value">
                  {dayjs().diff(dayjs(loanData?.dob), "year")}{" "}
                </div>
              </div>
              <div className="contact-item">
                <div className="label">Email:</div>
                <div className="value">{loanData?.emailId}</div>
              </div>
              <div className="contact-item">
                <div className="label">Phone:</div>
                <div className="value">{loanData?.contactNo}</div>
              </div>
            </div>
            <hr></hr>
            <div className="allocations-section ">
              <h3>This month allocations</h3>
              <div className="allocations-grid min-border-color">
                <table>
                  <thead className="table-row-background">
                    {[
                      { label: "MM", key: "MM" },
                      { label: "ALDI", key: "ALDI" },
                      { label: "BLOOMS", key: "BLOOMS" },
                      { label: "TRANSPORT", key: "TRANSPORT" },
                      { label: "EXTENDED", key: "EXTENDED" },
                      { label: "JBHIFI", key: "JBHIFI" },
                      { label: "GRILLD", key: "GRILLD" },
                    ].map((header) => (
                      <th className="w-25 text-center">{header.label}</th>
                    ))}
                  </thead>
                  <tbody>
                    <td className="text-center">{loanData?.currentMonthAllocationCounts?.MM || 0}</td>
                    <td className="text-center">{loanData?.currentMonthAllocationCounts?.ALDI || 0}</td>
                    <td className="text-center">{loanData?.currentMonthAllocationCounts?.BLOOMS || 0}</td>
                    <td className="text-center">
                      {loanData?.currentMonthAllocationCounts?.TRANSPORT || 0}
                    </td>
                    <td className="text-center">
                      {loanData?.currentMonthAllocationCounts?.EXTENDED || 0}
                    </td>
                    <td className="text-center">
                      {loanData?.currentMonthAllocationCounts?.JBHIFI || 0}
                    </td>
                    <td className="text-center">
                      {loanData?.currentMonthAllocationCounts?.GRILLD || 0}
                    </td>
                  </tbody>
                </table>
              </div>
            </div>
            <hr></hr>
            <div className="history-section">
              <h5>Shopper History:</h5>
              <div className="reports-card table-row-background">
                <div className="reports-vs">
                  <div className="reports-total">
                    {loanData?.totalReportCounts?.total || 0} Reports
                  </div>
                  <div className="reports-grid">
                    <div className="allocations-grid min-border-color">
                      <table>
                        <thead className="table-row-background">
                          {["ALDI", "BLOOMS", "MM", "TRANSPORT", "EXTENDED", "JBHIFI","GRILLD"].map((header) => (
                            <th className="w-25 text-center">{header}</th>
                          ))}
                        </thead>
                        <tbody>
                          <td className="text-center">{loanData?.totalReportCounts?.ALDI}</td>
                          <td className="text-center">{loanData?.totalReportCounts?.BLOOMS}</td>
                          <td className="text-center">{loanData?.totalReportCounts?.MM}</td>
                          <td className="text-center">{loanData?.totalReportCounts?.TRANSPORT}</td>
                          <td className="text-center">{loanData?.totalReportCounts?.EXTENDED}</td>
                          <td className="text-center">{loanData?.totalReportCounts?.JBHIFI}</td>
                          <td className="text-center">{loanData?.totalReportCounts?.GRILLD}</td>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="member-since">
                  <div className="label">Member Since:</div>
                  <div className="value">
                    {getTimeSinceCreated(loanData?.createdOn)}
                  </div>
                </div>
                <div className="member-since">
                  <div className="label">Last Report Rating:</div>
                  <div className="value">
                    <div>
                      {loanData?.lastReportRatingData?.MM?.reportCreatedDate
                        ? `MM -- ${loanData.lastReportRatingData.MM.reportMonth
                        }/${loanData.lastReportRatingData.MM.reportYear
                        } -- ${formatDate(
                          loanData.lastReportRatingData.MM.submitDate
                        )} -- ${loanData.lastReportRatingData.MM.score}/100`
                        : "MM -- N/A"}
                    </div>
                    <div>
                      {loanData?.lastReportRatingData?.ALDI?.reportCreatedDate
                        ? `ALDI -- ${loanData.lastReportRatingData.ALDI.reportMonth
                        }/${loanData.lastReportRatingData.ALDI.reportYear
                        } -- ${formatDate(
                          loanData.lastReportRatingData.ALDI.submitDate
                        )} -- ${loanData.lastReportRatingData.ALDI.score}/100`
                        : "ALDI -- N/A"}
                    </div>
                    <div>
                      {loanData?.lastReportRatingData?.BLOOMS?.reportCreatedDate
                        ? `BLOOMS -- ${loanData.lastReportRatingData.BLOOMS.reportMonth
                        }/${loanData.lastReportRatingData.BLOOMS.reportYear
                        } -- ${formatDate(
                          loanData.lastReportRatingData.BLOOMS.submitDate
                        )} -- ${loanData.lastReportRatingData.BLOOMS.score}/100`
                        : "BLOOMS -- N/A"}
                    </div>
                    <div>
                      {loanData?.lastReportRatingData?.EXTENDED?.reportCreatedDate
                        ? `EXTENDED -- ${loanData.lastReportRatingData.EXTENDED.reportMonth
                        }/${loanData.lastReportRatingData.EXTENDED.reportYear
                        } -- ${formatDate(
                          loanData.lastReportRatingData.EXTENDED.submitDate
                        )} -- ${loanData.lastReportRatingData.EXTENDED.score}/100`
                        : "EXTENDED -- N/A"}
                    </div>
                    <div>
                      {loanData?.lastReportRatingData?.JBHIFI?.reportCreatedDate
                        ? `JBHIFI -- ${loanData.lastReportRatingData.JBHIFI.reportMonth
                        }/${loanData.lastReportRatingData.JBHIFI.reportYear
                        } -- ${formatDate(
                          loanData.lastReportRatingData.JBHIFI.submitDate
                        )} -- ${loanData.lastReportRatingData.JBHIFI.score}/100`
                        : "JBHIFI -- N/A"}
                    </div>
                    <div>
                      {loanData?.lastReportRatingData?.GRILLD?.reportCreatedDate
                        ? `GRILLD -- ${loanData.lastReportRatingData.GRILLD.reportMonth
                        }/${loanData.lastReportRatingData.GRILLD.reportYear
                        } -- ${formatDate(
                          loanData.lastReportRatingData.GRILLD.submitDate
                        )} -- ${loanData.lastReportRatingData.GRILLD.score}/100`
                        : "GRILLD -- N/A"}
                    </div>
                  </div>
                </div>
                <div className="member-since">
                  <div className="label">Last Month:</div>
                  <div className="value">
                    {`${loanData?.totalReportCounts?.totalLastMonthReportCounts} Reports` ||
                      "0 Reports"}
                  </div>
                </div>
                <div className="member-since">
                  <div className="label">Overall Rating:</div>
                  <div className="value">
                    {loanData?.shopperOverAllRating || "N/A"}
                  </div>
                </div>
                <div className="member-since">
                  <div className="label">Editors comment:</div>
                  <div
                    className="value"
                    dangerouslySetInnerHTML={{
                      __html:
                        // [
                        //   loanData?.lastReportRatingData?.MM,
                        //   loanData?.lastReportRatingData?.ALDI,
                        //   loanData?.lastReportRatingData?.BLOOMS,
                        //   loanData?.lastReportRatingData?.TRANSPORT,
                        //   loanData?.lastReportRatingData?.EXTENDED,
                        //   loanData?.lastReportRatingData?.JBHIFI,
                        // ]
                        //   .filter((r) => r?.submitDate)
                        //   .sort(
                        //     (a, b) =>
                        //       new Date(b.submitDate).getTime() -
                        //       new Date(a.submitDate).getTime()
                        //   )[0]?.editorComment || "No comments available",
                        //                         [
                        //   loanData?.lastReportRatingData?.MM,
                        //   loanData?.lastReportRatingData?.ALDI,
                        //   loanData?.lastReportRatingData?.BLOOMS,
                        //   loanData?.lastReportRatingData?.TRANSPORT,
                        //   loanData?.lastReportRatingData?.EXTENDED,
                        //   loanData?.lastReportRatingData?.JBHIFI,
                        // ]
                        //   .map((r) => r?.editorComment)
                        //   .filter(Boolean)
                        //   .join("<br/><br/>") || "No comments available",

                        //                 }}
                        [
                          { name: "MM", ...loanData?.lastReportRatingData?.MM },
                          { name: "ALDI", ...loanData?.lastReportRatingData?.ALDI },
                          { name: "BLOOMS", ...loanData?.lastReportRatingData?.BLOOMS },
                          { name: "TRANSPORT", ...loanData?.lastReportRatingData?.TRANSPORT },
                          { name: "EXTENDED", ...loanData?.lastReportRatingData?.EXTENDED },
                          { name: "JBHIFI", ...loanData?.lastReportRatingData?.JBHIFI },
                          { name: "GRILLD", ...loanData?.lastReportRatingData?.GRILLD },
                        ]
                          .filter((r) => r.editorComment)
                          .map(
                            (r) =>
                              `
                            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px;">
                            <strong style="font-size:12px;font-weight:600;">
                            ${r.name}
                            </strong>
                            ${r.submitDate
                                ? `<span style="font-size:10px;">
                              ${dayjs(r.submitDate).format("DD/MM/YYYY HH:mm")}
                            </span>`
                                : ""
                              }
                          </div>
                        <div style="font-size:13px;">
                        ${r.editorComment}
                        </div>`
                          )
                          .join("<hr/>") || "No comments available",
                    }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="notes-section ">
              <div className="notes-container  min-border-color">
                <h3 className="table-row-background">Shopper Notes</h3>{" "}
                <div style={{ padding: "10px" }}>
                  <textarea
                    placeholder="Enter shopper notes..."
                    value={shopperNotes}
                    onChange={(e) => setShopperNotes(e.target.value)}
                    onFocus={handleOnFocus}
                    ref={shoppernoteRef}
                  />
                  <Button
                    className="save-button table-row-background"
                    onClick={() => saveShopperNotes(loanData.userId)}
                  >
                    Save shopper notes
                  </Button>
                </div>
              </div>
              <div className="notes-container  min-border-color">
                <h3 className="table-row-background">Training Notes</h3>{" "}
                <div style={{ padding: "10px" }}>
                  <textarea
                    placeholder="Enter training notes..."
                    value={trainingNotes}
                    onFocus={handleOnFocus2}
                    ref={trainingnoteRef}
                    onChange={(e) => setTrainingNotes(e.target.value)}
                  />
                  <Button
                    className="save-button table-row-background"
                    onClick={() => saveTrainingNotes(loanData.userId)}
                  >
                    Save training notes
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog open={openReasonDialog} onClose={() => setOpenReasonDialog(false)}>
        <DialogContent>
          <TextField
            required
            fullWidth
            label="Reason for Deactivation"
            value={reasonForDeactive}
            onChange={(e) => setReasonForDeactive(e.target.value)}
            sx={{
              width: "300px",
              ".MuiOutlinedInput-input": { padding: "10px" },
              ".MuiInputLabel-root": { top: "-6px" }
            }}
          />

          <Box display="flex" justifyContent="space-between" mt={3}>
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                setOpenReasonDialog(false);
                setReasonForDeactive("");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="table-row-background"
              onClick={handleSubmitDeactiveReason}
            >
              Submit
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box >
  );
};
export default Dcrage;
